import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorScaledOrder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M20.2 4.3a.75.75 0 0 0 0-1.5h-16a.75.75 0 0 0 0 1.5h16ZM13.2 8.3a.75.75 0 0 0 0-1.5H4.666a.75.75 0 1 0 0 1.5H13.2Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M20.95 11.55a.75.75 0 0 1-.75.75h-16a.75.75 0 1 1 0-1.5h16a.75.75 0 0 1 .75.75ZM18.95 15.55a.75.75 0 0 1-.75.75h-14a.75.75 0 1 1 0-1.5h14a.75.75 0 0 1 .75.75ZM13.2 20.3a.75.75 0 1 0 0-1.5H4.667a.75.75 0 0 0 0 1.5H13.2Z"
    />
  </svg>
);
export default SvgTwoColorScaledOrder;
